/**
 * <hero-slider> — autorotating fade slider with dot pager and reduced-motion support.
 *
 * Inputs (data-*):
 *   data-autoplay="true|false"
 *   data-interval="6500" (ms)
 *   data-respect-reduced-motion="true|false"
 *
 * Slides are children with [data-slide]; dot pager is [data-slide-pager="N"].
 */

class HeroSlider extends globalThis.ThemeElement {
  connectedCallback() {
    this.slides = this.$$('[data-slide]');
    this.pagers = this.$$('[data-slide-pager]');
    this.index = 0;
    this.timer = null;

    this.autoplay = this.dataset.autoplay !== 'false';
    this.interval = parseInt(this.dataset.interval || '6500', 10);
    this.respectRM = this.dataset.respectReducedMotion !== 'false';

    if (this.respectRM && globalThis.JunneTheme.reducedMotion.matches) {
      this.autoplay = false;
    }

    for (const btn of this.pagers) {
      this.on(btn, 'click', () => this.go(parseInt(btn.dataset.slidePager, 10)));
    }

    this.on(this, 'pointerenter', () => this.pause());
    this.on(this, 'pointerleave', () => this.resume());
    this.on(this, 'focusin', () => this.pause());
    this.on(this, 'focusout', () => this.resume());

    if (typeof IntersectionObserver !== 'undefined') {
      this.io = new IntersectionObserver((entries) => {
        for (const e of entries) {
          if (e.isIntersecting) this.resume();
          else this.pause();
        }
      }, { threshold: 0.2 });
      this.io.observe(this);
    } else {
      this.start();
    }
  }

  go(i) {
    if (!this.slides.length) return;
    this.index = (i + this.slides.length) % this.slides.length;
    this.slides.forEach((s, idx) => s.setAttribute('aria-current', idx === this.index ? 'true' : 'false'));
    this.pagers.forEach((p, idx) => p.setAttribute('aria-selected', idx === this.index ? 'true' : 'false'));
  }

  next() { this.go(this.index + 1); }

  start() {
    if (!this.autoplay || this.timer) return;
    this.timer = setInterval(() => this.next(), this.interval);
  }

  pause() { clearInterval(this.timer); this.timer = null; }

  resume() { if (this.autoplay) this.start(); }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.pause();
    this.io?.disconnect();
  }
}

if (!customElements.get('hero-slider')) customElements.define('hero-slider', HeroSlider);
